<template>
	<div>
		<base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-pink">
			<!-- Card stats -->
			<b-row>
				<b-col xl="6" md="6">
					<stats-card title="Referencia de valores" type="gradient-orange" class="mb-4">
						<!-- <stats-card > -->

						<template slot="footer">
							<br />
							<div>
								<img src="../assets/mapvalues.png" class="img-fluid" alt="Responsive image" />
							</div>
						</template>
					</stats-card>
				</b-col>
			</b-row>
			<br />

			<b-row>
				<b-col xl="6" md="6">
					<stats-card title="CIUDAD" type="gradient-red" icon="ni ni-active-40" class="mb-4">
						<template slot="footer">
							<div>
								<input
									type="text"
									placeholder="Ingresa una ubicación"
									id="autocompletemoreira"
									style="width: 100%"
									class="mb-4"
								/>
								<br />
								<br />
							</div>
						</template>
					</stats-card>
				</b-col>

				<b-col xl="6" md="6">
					<stats-card
						title="TIPO DE INMUEBLE"
						type="gradient-green"
						icon="ni ni-money-coins"
						class="mb-4"
					>
						<template slot="footer">
							<select class="form-control" @change="changevalorRegistro($event)">
								<option value selected disabled>Seleccione el valor del registro</option>
								<option
									v-for="valorRegistro in valorRegistros"
									:value="valorRegistro.id"
									:key="valorRegistro.id"
								>{{ valorRegistro.name }}</option>
							</select>
							<br />
							<br />
							<p>
								<span>Valor seleccionado: {{ selectedvalorRegistro }}</span>
							</p>
						</template>
					</stats-card>
				</b-col>
				<b-col xl="6" md="6">
					<stats-card
						title="TOTAL REGISTROS"
						type="gradient-green"
						icon="ni ni-money-coins"
						class="mb-4"
					>
						<template slot="footer">
							<span class="text-success mr-2">Registros Totales: {{ totalRegistros }}</span>
						</template>
					</stats-card>
				</b-col>
			</b-row>
			<b-button v-model="ad" @click="aplicarFiltros">Aplicar Filtros</b-button>
		</base-header>

		<b-container fluid class="mt--7">
			<b-row>
				<b-col>
					<b-card style="width: 100%; height: 500px">
						<gmap-map
							ref="mapRef"
							id="map"
							:zoom="15"
							mapTypeId="satellite"
							:center="{
								lat:-0.25054608261955746,
								lng:-78.53720689954537
							}"
						></gmap-map>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import axios from "axios";
import { gmapApi } from 'vue2-google-maps'
// import firebase from "firebase/compat/app";
// import "firebase/compat/firestore";

// const firebaseConfig = {
// 	apiKey: "AIzaSyAVAPuU89LgvU20UMzDStU1nerH2Zb2qXA",
// 	authDomain: "vlactest01.firebaseapp.com",
// 	databaseURL: "https://vlactest01-default-rtdb.firebaseio.com",
// 	projectId: "vlactest01",
// 	storageBucket: "vlactest01.appspot.com",
// 	messagingSenderId: "259263606119",
// 	appId: "1:259263606119:web:e11295c0ecb61c2847d3c2",
// 	measurementId: "G-K6YVZQNM17",
// };
// firebase.initializeApp(firebaseConfig);
// const db = firebase.firestore();


import { db } from '../firebase'

let centroMapa;
export default {
	mounted() {
		this.$refs.mapRef.$mapPromise.then((map) => {
			let autocomplete = new this.google.maps.places.Autocomplete(
				document.getElementById("autocompletemoreira"),
				{
					bounds: new this.google.maps.LatLngBounds(new this.google.maps.LatLng()),
					componentRestrictions: { country: "ECU" },
				}
			);
			autocomplete.addListener("place_changed", () => {
				centroMapa = autocomplete.getPlace();
				console.log(place, "AQUIIIESTABIEN");
				this.showUserLocationOnTheMap(
					centroMapa.geometry.location.lat(),
					centroMapa.geometry.location.lng()
				);
			});

			var heatMapData = [
				{
					location: new this.google.maps.LatLng(
						-0.25054608261955746,
						-78.53720689954537
					),
					weight: 5000,

					gradient: "rgba(0, 255, 255, 0)"
				},


				{
					location: new this.google.maps.LatLng(
						-0.2305886811099789,
						-78.52614129159635
					),
					weight: 2,
				},
				{
					location: new this.google.maps.LatLng(
						-0.110834264262997,
						-78.42109820324185
					),
					weight: 80,

				},
				{
					location: new this.google.maps.LatLng(
						-0.24837326764972095,
						-78.54402158789993
					),
					weight: 2,
					radius: 200,
				},
			];

			var heatmap = new this.google.maps.visualization.HeatmapLayer({
				data: heatMapData,
			});
			heatmap.setMap(map);
		})
	},
	name: "app1",
	data() {
		return {
			ad: null,
			valorRegistros: [
				{ name: "Casa", id: 1 },
				{ name: "Galpon", id: 2 },
				{ name: "Terreno", id: 3 },
				{ name: "Departamento", id: 4 },
				{ name: "Oficina", id: 5 },
				{ name: "Inmueble", id: 6 },
			],
			selectedvalorRegistro: null,
			totalRegistros: null,
		};
	},
	computed: {
		google: gmapApi,
	},
	methods: {
		changevalorRegistro(event) {
			this.selectedvalorRegistro =
				event.target.options[event.target.options.selectedIndex].text;
		},

		aplicarFiltros() {
			/*
	1. Pasar de alguna manera la ubicación desde el autocomplete hacia aplicar filtros
	*/

			console.log(this.selectedvalorRegistro + "VR");

			let tipoReg = "tipoRegistro";
			let heatMapData = [];
			let comparative;
			let valorSel;
			let precioMetroCuadrado;
			if (this.selectedvalorRegistro == null) {
				comparative = "in";
				valorSel = [
					"casa",
					"terreno",
					"galpon",
					"departamento",
					"oficina",
					"inmueble",
				];
			} else {
				console.log("existe valor de registro");
				comparative = "==";

				switch (this.selectedvalorRegistro) {
					case "Galpon":
						valorSel = "galpon";
						break;
					case "Terreno":
						valorSel = "terreno";
						break;
					case "Casa":
						valorSel = "casa";
						break;
					case "Departamento":
						valorSel = "departamento";
						break;
					case "Oficina":
						valorSel = "oficina";
						break;
					case "Inmueble":
						valorSel = "inmueble";
						break;
				}
			}

			console.log(tipoReg + "    " + comparative + "    " + valorSel);
			db.collection("inmobiliario")
				.where(tipoReg, comparative, valorSel)
				.get()
				.then((querySnapshot) => {
					console.log(querySnapshot.size.toString());
					this.totalRegistros = querySnapshot.size.toString();
					console.log(this.totalRegistros);

					const map = new this.google.maps.Map(document.getElementById("map"), {
						zoom: 15,
						center: new this.google.maps.LatLng(
							centroMapa.geometry.location.lat(),
							centroMapa.geometry.location.lng()
						),
						mapTypeId: "satellite",
					});
					querySnapshot.forEach((doc) => {
						if (doc.data().tipoRegistro == "casa") {
							precioMetroCuadrado =
								Number(doc.data().precio) / Number(doc.data().areaConstruccion);
							console.log(precioMetroCuadrado + "precio Metro");
							console.log(typeof precioMetroCuadrado);
						}
						//crear marcador si es terreno

						if (doc.data().tipoRegistro == "terreno") {
							precioMetroCuadrado =
								Number(doc.data().precio) / Number(doc.data().areaTerreno);
							console.log(precioMetroCuadrado + "precio Metro");
							console.log(typeof precioMetroCuadrado);
						}
						//crear marcador si es oficina
						if (doc.data().tipoRegistro == "oficina") {
							precioMetroCuadrado =
								Number(doc.data().precio) / Number(doc.data().areaOficina);
							console.log(precioMetroCuadrado + "precio Metro");
							console.log(typeof precioMetroCuadrado);
						}
						//crear marcador si es departamento
						if (doc.data().tipoRegistro == "departamento") {
							precioMetroCuadrado =
								Number(doc.data().precio) / Number(doc.data().areaDepartamento);
							console.log(precioMetroCuadrado + "precio Metro");
							console.log(typeof precioMetroCuadrado);
						}
						//crear marcador si es galpon
						if (doc.data().tipoRegistro == "galpon") {
							precioMetroCuadrado =
								Number(doc.data().precio) / Number(doc.data().area);
							console.log(precioMetroCuadrado + "precio Metro");
							console.log(typeof precioMetroCuadrado);
						}
						//crear marcador si es inmueble
						if (doc.data().tipoRegistro == "inmueble") {
							precioMetroCuadrado =
								Number(doc.data().precio) / Number(doc.data().areaConstruccion);
							console.log(precioMetroCuadrado + "precio Metro");
							console.log(typeof precioMetroCuadrado);
						}

						let insertarHeatmap;
						console.log("aqui inicia función");
						if (0 < precioMetroCuadrado && precioMetroCuadrado < 54) {
							console.log("aqui weight 10");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 0.1,
							};
							heatMapData.push(insertarHeatmap);
						} else if (54 <= precioMetroCuadrado && precioMetroCuadrado < 77) {
							console.log("aqui weight 20");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 0.4,
							};
							heatMapData.push(insertarHeatmap);
						} else if (78 <= precioMetroCuadrado && precioMetroCuadrado < 102) {
							console.log("aqui weight 30");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 0.7,
							};
							heatMapData.push(insertarHeatmap);
						} else if (
							102 <= precioMetroCuadrado &&
							precioMetroCuadrado < 143
						) {
							console.log("aqui weight 40");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 1,
							};
							heatMapData.push(insertarHeatmap);
						} else if (
							143 <= precioMetroCuadrado &&
							precioMetroCuadrado < 184
						) {
							console.log("aqui weight 50");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 1.3,
							};
							heatMapData.push(insertarHeatmap);
						} else if (
							184 <= precioMetroCuadrado &&
							precioMetroCuadrado < 277
						) {
							console.log("aqui weight 60");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 1.6,
							};
							heatMapData.push(insertarHeatmap);
						} else if (
							277 <= precioMetroCuadrado &&
							precioMetroCuadrado < 341
						) {
							console.log("aqui weight 70");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 1.9,
							};
							heatMapData.push(insertarHeatmap);
						} else if (
							341 <= precioMetroCuadrado &&
							precioMetroCuadrado < 428
						) {
							console.log("aqui weight 80");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 2.2,
							};
							heatMapData.push(insertarHeatmap);
						} else if (
							428 <= precioMetroCuadrado &&
							precioMetroCuadrado < 554
						) {
							console.log("aqui weight 90");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 2.5,
							};
							heatMapData.push(insertarHeatmap);
						} else if (
							554 <= precioMetroCuadrado &&
							precioMetroCuadrado < 860
						) {
							console.log("aqui weight 100");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 2.8,
							};
							heatMapData.push(insertarHeatmap);
						} else if (
							860 <= precioMetroCuadrado &&
							precioMetroCuadrado < 1302
						) {
							console.log("aqui weight 110");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 3.1,
							};
							heatMapData.push(insertarHeatmap);
						} else if (
							1302 <= precioMetroCuadrado &&
							precioMetroCuadrado < 1695
						) {
							console.log("aqui weight 120");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 3.4,
							};
							heatMapData.push(insertarHeatmap);
						} else if (1695 <= precioMetroCuadrado) {
							console.log("aqui weight 130");
							insertarHeatmap = {
								location: new this.google.maps.LatLng(
									doc.data().ubicacion.latitude,
									doc.data().ubicacion.longitude
								),
								weight: 100,
							};
							heatMapData.push(insertarHeatmap);
						}
					});

					var heatmap = new this.google.maps.visualization.HeatmapLayer({
						data: heatMapData,
						map: map,
						radius: 40,
						opacity: 1,
					});
					const gradient = [
						"rgba(0, 255, 255, 0)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 191, 255, 1)",
						"rgba(0, 127, 255, 1)",
						"rgba(0, 63, 255, 1)",
						"rgba(0, 0, 255, 1)",
						"rgba(0, 0, 223, 1)",
						"rgba(0, 0, 191, 1)",
						"rgba(0, 0, 159, 1)",
						"rgba(0, 0, 127, 1)",
						"rgba(63, 0, 91, 1)",
						"rgba(127, 0, 63, 1)",
						"rgba(191, 0, 31, 1)",
						"rgba(255, 0, 0, 1)",
					];

					console.log("aquiii" + JSON.stringify(heatMapData) + "aqui datos");
					heatmap.set("gradient", heatmap.get("gradient") ? null : gradient);
					heatmap.set("radius", heatmap.get("radius") ? null : 20);
					heatmap.setMap(map);
					const gradient1 = [
						"rgba(0, 255, 255, 0)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 255, 255, 1)",
						"rgba(0, 255, 255, 1)",
						"rgba(255, 0, 0, 1)",
					];
					var transitLayer = new this.google.maps.TransitLayer();
					heatmap.set("gradient", heatmap.get("gradient") ? null : gradient1);
					transitLayer.setMap(map);
				})
				.catch((error) => {
					console.log("Error getting documents: ", error);
				});
		},

		locatorButtonPressed() {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						this.getAddressFrom(
							position.coords.latitude,
							position.coords.longitude
						);
						console.log(position.coords.latitude);
						console.log(position.coords.longitude);
						this.showUserLocationOnTheMap(
							position.coords.latitude,
							position.coords.longitude
						);
					},
					(error) => {
						console.log(error.message);
					}
				);
			} else {
				console.log("NO ESTA FUNCIONANDO");
			}
		},
		getAddressFrom(lat, long) {
			axios
				.get(
					"https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
					lat +
					"," +
					long +
					"&key=AIzaSyDtgz9_16qdAHXWPwzhnpNLJKBUR_THdYc"
				)
				.then((response) => {
					if (response.data.error_message) {
						console.log(response.data.error_message);
					} else {
						console.log(response.data.results[0].formatted_address);
					}
				})
				.catch((error) => {
					console.log(error.message);
				});
		},
		showUserLocationOnTheMap(latitude, longitude) {
			console.log("AQUI ESTA CREAADO EL MAPA");
			//crear mapa
			let map = new this.google.maps.Map(document.getElementById("map"), {
				zoom: 13,
				center: new this.google.maps.LatLng(latitude, longitude),

				mapTypeId: this.google.maps.MapTypeId.ROADMAP,
			});
			new this.google.maps.Marker({
				position: new this.google.maps.LatLng(latitude, longitude),
				map: map,
			});
		},
	},
};
</script>

<style scoped>
	.pac-icon {
		display: none;
	}
	.pac-item {
		padding: 10px;
		font-size: 16px;
		cursor: pointer;
	}
	.pac-item:hover {
		background-color: white;
	}
	.pac-item:query {
		font-size: 14px;
	}

	#map {
		position: absolute;
		top: 0%;
		right: 0%;
		bottom: 0%;
		left: 0%;
		background-color: white;
	}
</style>
